import {
  MONITOR_ORDER_COUNT_LOAD,
  MONITOR_ORDER_COUNT_SUCCESS,
  MONITOR_ORDER_COUNT_ERROR,
  MONITOR_BILL_COUNT_LOAD,
  MONITOR_BILL_COUNT_SUCCESS
} from "./actionTypes"

export const orderCountError = error => {
  return {
    type: MONITOR_ORDER_COUNT_ERROR,
    payload: error,
  }
}
export const initLoadOrdersCount = (filter) => {
  return {
    type: MONITOR_ORDER_COUNT_LOAD,
    payload: filter,
  }
}

export const loadOrdersCount = data => {
  return {
    type: MONITOR_ORDER_COUNT_SUCCESS,
    payload: data,
  }


}
export const initLoadBillCount = (filter) => {
  return {
    type: MONITOR_BILL_COUNT_LOAD,
    payload: filter,
  }
}

export const loadBillsCount = data => {
  return {
    type: MONITOR_BILL_COUNT_SUCCESS,
    payload: data,
  }


}
